<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'staffBroadcastTitle' | translate }}</h1>
      <p class="st-subtitle">{{ 'staffBroadcastSubtitle' | translate }}</p>
    </div>
    <button class="st-btn st-btn-primary" *ngIf="canCreateBroadcast" (click)="openComposer()"><i class="ri-add-line"></i> {{ 'bv2NewBroadcastBtn' | translate }}</button>
  </div>

  <div class="sb-stats-row" *ngIf="!isLoadingBroadcasts && isSuperAdmin">
    <div class="sb-stat-card" *ngFor="let stat of stats">
      <div class="sb-stat-icon" [ngClass]="getStatIconClass(stat.slug)">
        <i [ngClass]="getStatIcon(stat.slug)"></i>
      </div>
      <div class="sb-stat-text">
        <div class="sb-stat-value">{{ stat.value }}</div>
        <div class="sb-stat-label">{{ stat.title }}</div>
      </div>
    </div>
  </div>
  <div class="sb-stats-row" *ngIf="isLoadingBroadcasts && isSuperAdmin">
    <div class="sb-stat-card sb-stat-card-skeleton" *ngFor="let s of skeletonStatCards"></div>
  </div>

  <div class="sb-table-card">
    <div class="sb-toolbar">
      <div class="sb-search-box">
        <i class="ri-search-line"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="{{ 'bv2SearchPlaceholder' | translate }}" />
      </div>

      <div class="sb-filters">
        <select class="sb-native-select" [(ngModel)]="selectedStatusLabel" (change)="selectStatus(selectedStatusLabel)">
          <option [ngValue]="null">{{ 'bv2AllStatusOption' | translate }}</option>
          <option *ngFor="let option of statusFilterOptions" [value]="option.label">{{ option.label }}</option>
        </select>

        <div class="sb-date-filter-wrap">
          <select class="sb-native-select" [ngModel]="selectedDateFilterKey" (change)="onDateFilterChange($event)">
            <option value="All time">{{ 'bv2AllTimeOption' | translate }}</option>
            <option value="Last 30 days">{{ 'bv2Last30DaysOption' | translate }}</option>
            <option value="Last 7 days">{{ 'bv2Last7DaysOption' | translate }}</option>
            <option value="Choose date">{{ 'bv2ChooseDateOption' | translate }}</option>
            <option *ngIf="customDateLabel" [value]="customDateLabel">{{ customDateLabel }}</option>
          </select>

          <div class="sb-inline-calendar-wrap" *ngIf="isChooseDateOpen">
            <p-calendar
              [(ngModel)]="selectedDate"
              [inline]="true"
              dateFormat="M dd, yy"
              (onSelect)="onCalendarDateSelected($event)"
            ></p-calendar>
          </div>
        </div>
      </div>
    </div>

    <div class="sb-table-scroll">
      <table class="sb-table">
        <thead>
          <tr>
            <th>{{ 'bv2ColBroadcast' | translate }}</th>
            <th>{{ 'bv2ColSentOn' | translate }}</th>
            <th *ngIf="isSuperAdmin">{{ 'bv2ColViewsReadPercent' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoadingBroadcasts && !broadcasts.length">
          <tr>
            <td [attr.colspan]="isSuperAdmin ? 4 : 3">
              <div class="sb-no-data">
                <i class="ri-inbox-line"></i>
                <div class="sb-no-data-text">{{ 'bv2NoBroadcastsFound' | translate }}</div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!isLoadingBroadcasts">
          <tr *ngFor="let b of broadcasts" class="sb-clickable-row" [class.sb-row-unread]="!b.isRead" (click)="openBroadcast(b)">
            <td>
              <div class="sb-broadcast-title-row">
                <span class="sb-unread-dot" *ngIf="!b.isRead"></span>
                <div class="sb-broadcast-title">{{ b.subject }}</div>
                <span class="sb-media-badge" *ngIf="b.attachmentCount > 0">
                  <i class="ri-attachment-2"></i>
                  {{ b.attachmentCount }}
                </span>
              </div>
              <div class="sb-broadcast-subtitle">{{ 'bv2SentToPrefix' | translate }}{{ b.audience }}</div>
            </td>
            <td>
              <div class="sb-sent-date">{{ b.sentOnDate }}</div>
              <div class="sb-sent-time">{{ b.sentOnTime }}</div>
            </td>
            <td *ngIf="isSuperAdmin">
              <div class="sb-views-row">
                <span class="sb-views-count">{{ b.views }} {{ 'bv2ViewsSuffix' | translate }}</span>
                <span class="sb-read-percent">{{ b.readPercentage }}%</span>
              </div>
              <div class="sb-progress-track">
                <div class="sb-progress-fill" [style.width.%]="b.readPercentage"></div>
              </div>
            </td>
            <td class="sb-row-arrow">
              <i class="ri-arrow-right-s-line"></i>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="isLoadingBroadcasts">
          <tr *ngFor="let s of skeletonRows">
            <td colspan="4"><div class="sb-skeleton-line"></div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="sb-pagination-bar">
      <p-paginator
        [first]="paginatorFirst"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPageChange)="onPaginatorPageChange($event)"
      ></p-paginator>
    </div>
  </div>
</div>

<!-- Create Broadcast — right-side sidepopover -->
<div class="sb-drawer-overlay" *ngIf="showComposer" (click)="closeComposer()">
  <div class="sb-drawer" (click)="$event.stopPropagation()">
    <div class="sb-drawer-head">
      <h3 class="sb-drawer-title">{{ 'bv2NewBroadcastBtn' | translate }}</h3>
      <button class="sb-drawer-close" (click)="closeComposer()" [disabled]="submitting"><i class="ri-close-line"></i></button>
    </div>

    <div class="sb-drawer-body">
      <label class="sb-field-label">{{ 'bv2SendToLabel' | translate }}</label>
      <div class="sb-receiver-row" *ngIf="!loadingReceivers; else receiversLoading">
        <button
          type="button"
          class="sb-receiver-pill"
          *ngFor="let option of receiverOptions"
          [class.active]="selectedReceiverId === option.receiverId"
          [disabled]="submitting"
          (click)="selectReceiver(option.receiverId)"
        >
          {{ option.receiver }}
        </button>
      </div>
      <ng-template #receiversLoading>
        <p class="sb-receiver-loading">{{ 'pleaseWait' | translate }}</p>
      </ng-template>

      <label class="sb-field-label">{{ 'bv2TitleLabel' | translate }}</label>
      <input
        type="text"
        class="sb-input"
        [(ngModel)]="newTitle"
        placeholder="{{ 'bv2TitlePlaceholder' | translate }}"
        [disabled]="submitting"
      />

      <label class="sb-field-label">{{ 'bv2DescriptionLabel' | translate }}</label>
      <textarea
        class="sb-textarea"
        rows="5"
        [(ngModel)]="newMessage"
        placeholder="{{ 'bv2DescriptionPlaceholder' | translate }}"
        [disabled]="submitting"
      ></textarea>

      <label class="sb-field-label">
        {{ 'bv2AttachmentsLabel' | translate }}
        <span class="sb-field-optional">{{ 'bv2AttachmentsOptionalMark' | translate: { count: maxAttachments } }}</span>
      </label>
      <div class="sb-attachment-list" *ngIf="attachments.length">
        <div class="sb-attachment-chip" *ngFor="let file of attachments; let i = index">
          <i class="ri-file-line"></i>
          <span class="sb-attachment-name">{{ file.name }}</span>
          <i class="ri-close-line sb-attachment-remove" (click)="removeAttachment(i)"></i>
        </div>
      </div>
      <label class="sb-attachment-add" [class.sb-attachment-add-disabled]="attachments.length >= maxAttachments || submitting">
        <i class="ri-attachment-2"></i> {{ 'bv2AttachmentsLabel' | translate }}
        <input type="file" multiple accept="image/*,application/pdf" hidden (change)="onFilesSelected($event)" [disabled]="attachments.length >= maxAttachments || submitting" />
      </label>
      <p class="sb-field-note">{{ 'bv2AttachmentNote' | translate: { count: maxAttachments } }}</p>
    </div>

    <div class="sb-drawer-actions">
      <button class="st-btn st-btn-secondary" (click)="closeComposer()" [disabled]="submitting">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-primary" (click)="submitBroadcast()" [disabled]="submitting">
        <i class="ri-send-plane-line" *ngIf="!submitting"></i>
        {{ (submitting ? 'pleaseWait' : 'staffSendBtn') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Broadcast Details — right-side sidepopover. Everything here (header,
     description, meta, attachments) comes straight from the already-loaded
     list item; only the viewer list below is a fresh fetch, Super Admin only. -->
<div class="sb-drawer-overlay" *ngIf="showDetails && selectedBroadcast as b" (click)="closeDetails()">
  <div class="sb-drawer" (click)="$event.stopPropagation()">
    <div class="sb-drawer-head">
      <h3 class="sb-drawer-title">{{ b.subject }}</h3>
      <button class="sb-drawer-close" (click)="closeDetails()"><i class="ri-close-line"></i></button>
    </div>

    <div class="sb-drawer-body">
      <span class="st-chip st-chip-blue">{{ 'bv2SentToPrefix' | translate }}{{ b.audience }}</span>

      <p class="sb-details-message">{{ b.message }}</p>

      <p class="sb-details-sent-on">{{ 'bv2SentLabel' | translate }}{{ b.sentOnDate }} {{ b.sentOnTime }}</p>

      <div class="sb-detail-stats" *ngIf="isSuperAdmin">
        <div class="sb-detail-stat-card">
          <div class="sb-detail-stat-value">{{ b.expectedViews }}</div>
          <div class="sb-detail-stat-label">{{ 'bv2Recipients' | translate }}</div>
        </div>
        <div class="sb-detail-stat-card">
          <div class="sb-detail-stat-value sb-detail-stat-blue">{{ b.views }}</div>
          <div class="sb-detail-stat-label">{{ 'bv2Viewed' | translate }}</div>
        </div>
        <div class="sb-detail-stat-card">
          <div class="sb-detail-stat-value sb-detail-stat-green">{{ b.readPercentage }}%</div>
          <div class="sb-detail-stat-label">{{ 'bv2ReadRate' | translate }}</div>
        </div>
      </div>

      <ng-container *ngIf="b.media.length">
        <div class="sb-field-label">{{ 'bv2AttachmentsHeading' | translate }} ({{ b.media.length }})</div>
        <div class="sb-attachment-list">
          <div class="sb-attachment-row" *ngFor="let media of b.media" (click)="openMediaPreview(media)">
            <i class="ri-image-line" *ngIf="isImageMedia(media.broadcastMediaType)"></i>
            <i class="ri-file-pdf-line" *ngIf="!isImageMedia(media.broadcastMediaType)"></i>
            <span class="sb-attachment-name">{{ media.broadcastMediaType }}</span>
            <i class="ri-download-line sb-attachment-download"></i>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isSuperAdmin">
        <div class="sb-viewers-head">
          <span class="sb-field-label" style="margin:0;">{{ 'bv2WhoViewedHeading' | translate }}</span>
          <span class="st-chip st-chip-grey">{{ b.views }} {{ 'bv2ViewsSuffix' | translate }}</span>
          <button type="button" class="sb-viewers-search-toggle" (click)="toggleViewersSearch()"><i class="ri-search-line"></i></button>
        </div>

        <div class="sb-search-row" *ngIf="viewersSearchOpen">
          <input
            type="text"
            class="sb-input"
            autofocus
            placeholder="{{ 'bv2SearchViewersPlaceholder' | translate }}"
            [ngModel]="viewersSearchTerm"
            (ngModelChange)="onViewersSearchInput($event)"
          />
        </div>

        <div class="sb-viewer-skeleton-list" *ngIf="loadingViewers">
          <div class="sb-viewer-skeleton-row" *ngFor="let s of [1,2,3,4]"></div>
        </div>

        <ng-container *ngIf="!loadingViewers">
          <div class="sb-viewer-row" *ngFor="let viewer of viewers; let i = index">
            <div class="sb-viewer-avatar" [ngClass]="avatarColor(i)">
              <img *ngIf="viewer.image" [src]="viewer.image" alt="{{ viewer.name }}" />
              <ng-container *ngIf="!viewer.image">{{ getInitials(viewer.name) }}</ng-container>
            </div>
            <div class="sb-viewer-info">
              <div class="sb-viewer-name">{{ viewer.name }}</div>
              <div class="sb-viewer-role">{{ viewer.type }}<ng-container *ngIf="viewer.className"> · {{ viewer.className }}</ng-container></div>
            </div>
            <div class="sb-viewer-status">
              <span *ngIf="viewer.readDate">{{ viewer.readDate }} {{ viewer.readTime }}</span>
              <span class="sb-viewer-not-viewed" *ngIf="!viewer.readDate">{{ 'bv2NotViewed' | translate }}</span>
            </div>
          </div>

          <p class="sb-empty" *ngIf="!viewers.length">{{ 'bv2NoViewsYet' | translate }}</p>

          <div class="sb-load-more" *ngIf="viewersPageNumber < viewersMaxPageNumber">
            <button class="st-btn st-btn-secondary" (click)="loadMoreViewers()" [disabled]="loadingMoreViewers">
              {{ (loadingMoreViewers ? 'pleaseWait' : 'loadMore') | translate }}
            </button>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- In-app media preview — images render directly, documents in a sandboxed
     iframe, same as web admin's broadcast-v2 media preview overlay. -->
<div class="sb-media-preview-overlay" *ngIf="isMediaPreviewOpen && previewMedia" (click)="closeMediaPreview()">
  <button type="button" class="sb-media-preview-close-btn" (click)="closeMediaPreview()">
    <i class="ri-close-line"></i>
  </button>
  <div class="sb-media-preview-content" [class.sb-media-preview-content-doc]="!isImageMedia(previewMedia.broadcastMediaType)" (click)="$event.stopPropagation()">
    <ng-container *ngIf="isImageMedia(previewMedia.broadcastMediaType); else documentPreview">
      <img [src]="previewMedia.broadcastMediaUrl" [alt]="previewMedia.broadcastMediaType" class="sb-media-preview-image" />
    </ng-container>
    <ng-template #documentPreview>
      <iframe [src]="previewMediaSafeUrl" class="sb-media-preview-iframe" [title]="'bv2PdfPreviewTitle' | translate"></iframe>
    </ng-template>
    <div class="sb-media-preview-label">{{ previewMedia.broadcastMediaType }}</div>
  </div>
</div>
